import Endpoints from '@commons/communication/endpoints.js'
import DateHelper from '@commons/util/DateHelper.js'

export default{
    mixins:[Endpoints,DateHelper],
    data: function() {
        return {
            orders:[],
            status:{
                PREPARED: "Leadva",
                PAYED: "Fizetve",
                CANCELED: "Törölve",
                IN_PROGRESS: "Teljesítés folyamatban",
                SHIPPING:"Szállítás alatt",
                COMPLETED: "Teljesítve",
                PREPARED_FOR_PAYMENT:"Fizetésre vár",
                PREPARED_FOR_SHIPPING:"Szállításra előkészítve",
                SHOP_AVAILABLE:"Átvehető a boltban",
            }
        };
    },
    created:function () {
        this.init();
    },
    methods:{
        init:function () {
            var self = this;

            this.connOrdersGet(function (r) {
                self.orders = r.data.list
            })
        },
        cancelOrder:function (id) {
            var self = this;

            this.connCancelOrder(id,function (r) {
                self.init();
            })
        },
        payOrder:function (id) {
            this.connNewOrderPayment(id,function (r) {
                window.location = r.data.message
            })
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/main/components/pages/dashboard/orders/Orders.js